import * as React from "react";
import {
    classNames,
    layout,
    PushButton,
    useStorageItemValue,
    View,
    ViewContent,
    ViewHeader,
    ViewHeaderItem
} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";
import barcodeScanner from "./barcode-scanner.png";
import {useLocalization} from "../i18n";

interface HelpProps {
    onClose: () => void;
}

export function Help(props: HelpProps) {
    const {onClose} = props;
    const {t} = useLocalization();
    const phone = useStorageItemValue<string>("tenantPhone");

    return (
        <View>
            <ViewHeader>
                <ViewHeaderItem fill className={classNames(styles.header, styles.headerTitle)}>
                    {t("HelpTitle")}
                </ViewHeaderItem>
                <ViewHeaderItem className={styles.header}>
                    <PushButton onClick={() => onClose()}>{t("Back")}</PushButton>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent>
                <div className={classNames(layout.vertical, styles.helpContainer)}>
                    <div className={styles.text}>
                        <div className={styles.helpText}>
                            {t("HelpInfo")}
                        </div>
                        {phone &&
                        <div className={styles.contact}>
                            <div className={styles.overline}>
                                {t("Contact")}
                            </div>
                            <div className={styles.contactPhone}>
                                {phone}
                            </div>
                        </div>
                        }
                    </div>
                    <div className={styles.barcodeScanner}>
                    </div>
                </div>
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    header: {
        padding: "1rem 2rem"
    },
    headerTitle: {
        fontSize: "1.75rem"
    },
    helpContainer: {
        flex: 1,
        height: "100%"
    },
    text: {
        display: "flex",
        flexDirection: "row",
        flex: 1,
        padding: "1rem 2rem",
        width: "100%",
        flexGrow: 1
    },
    helpText: {
        flex: 1,
        flexGrow: 2
    },
    contact: {
        flex: 1,
        flexGrow: 1,
        paddingLeft: "2rem"
    },
    overline: {
        textTransform: "uppercase"
    },
    contactPhone: {
        fontSize: "1.5rem",
        paddingTop: "0.25rem"
    },
    barcodeScanner: {
        backgroundImage: `url(${barcodeScanner})`,
        backgroundSize: "cover",
        backgroundPosition: "50% 42%",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        flex: 1,
        flexGrow: 2.5
    }
});